// nom des tpyes d'action du panier
export const MODIFY_BASKET = "MODIFY_BASKET";
export const CLEAN_BASKET = "CLEAN_BASKET";